import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .SVtraining': {
    '& p:last-child:not(.MuiTypography-root)': {
      marginTop: theme.spacing(1),
    },
    '& ul': {
      marginBottom: theme.spacing(2),
    },
  },
  '& .SVMarketing': {
    '& p:last-child:not(.MuiTypography-root)': {
      marginTop: theme.spacing(2),
    },
    '& .title': {
      color: theme.palette.secondary.dark,
    },
  },
  '& .SVWorkTogether': {
    '& ul': {
      marginTop: theme.spacing(2),
    },
  },

  '& .SVDark': {
    color: theme.palette.secondary.dark,
  },
  '& .SVOverview': {
    '& .title': {
      color: theme.palette.secondary.dark,
    },
  },
}));

export default StyledBox;
